export const storeRating = {
    init: () => {},
    trigger: () => {},
};
